import React, { forwardRef } from 'react';

import MUITable, { TableProps as MUITableProps } from '@material-ui/core/Table';

export interface TableProps extends MUITableProps {}

const Table = forwardRef<HTMLTableElement, TableProps>((props, ref) => {
  return <MUITable {...props} ref={ref} />;
});

export default Table;
